import { useState } from "react";

import { EntityId } from "@reduxjs/toolkit";

import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

import { DeviceList } from "./DeviceList";
import { Device } from "types/Device";
import { DeviceListVisibilityToggle } from "./DeviceListVisibilityToggle";

export interface DeviceListSidebarMenuProps {
    activeSiteId: EntityId;
    selectedDeviceIds?: EntityId[];
    onToggleDevice: (
        siteId: EntityId,
        deviceId: EntityId,
        selected: boolean,
    ) => void;
    onSetSelectionStateOfAllDevicesInSite: (
        siteId: EntityId,
        selected: boolean,
    ) => void;
    thumbnailRefreshIntervalInMs: number;

    devices: Device[];
}

export function DeviceListSidebarMenu(props: DeviceListSidebarMenuProps) {
    const [open, setOpen] = useState(true);

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon>
                    <PhotoCamera />
                </ListItemIcon>
                <ListItemText primary="Devices" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse
                in={open}
                timeout="auto"
                unmountOnExit
            >
                <DeviceList
                    key={`device-list-${props.activeSiteId}`}
                    onToggleDevice={(deviceId: EntityId, selected: boolean) =>
                        props.onToggleDevice(
                            props.activeSiteId,
                            deviceId,
                            selected,
                        )
                    }
                    devices={props.devices}
                    selectedDeviceIds={props.selectedDeviceIds}
                    selectAllToggleLabel="Restore default"
                    onToggleSelectAll={(selected: boolean) =>
                        props.onSetSelectionStateOfAllDevicesInSite(
                            props.activeSiteId,
                            selected,
                        )
                    }
                    thumbnailRefreshIntervalInMs={
                        props.thumbnailRefreshIntervalInMs
                    }
                    deviceListVisibilityToggleComponent={
                        DeviceListVisibilityToggle
                    }
                />
            </Collapse>
        </>
    );
}
